import { render } from "./putTime.vue?vue&type=template&id=1c728ce2&scoped=true"
import script from "./putTime.vue?vue&type=script&lang=js"
export * from "./putTime.vue?vue&type=script&lang=js"

import "./putTime.vue?vue&type=style&index=0&id=1c728ce2&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ssp-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c728ce2"]])

export default __exports__